var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3176 0C8.68826 0 5.74609 2.94215 5.74609 6.57149C5.74609 10.2008 8.68826 13.1429 12.3176 13.1429C15.947 13.1429 18.8891 10.2008 18.8891 6.57149C18.8891 2.94215 15.947 0 12.3176 0Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0075 14.1127C22.3991 13.4235 21.5062 12.9866 20.5123 12.9866H18.1239C16.2864 12.9866 14.7969 14.4762 14.7969 16.3137V24.6729C14.7969 26.5106 16.2864 28.0001 18.1239 28.0001H20.5123C21.5062 28.0001 22.3991 27.5631 23.0075 26.8739C23.3506 26.4853 23.3135 25.892 22.9249 25.5489C22.5361 25.2058 21.9429 25.2428 21.5998 25.6315C21.3328 25.934 20.9452 26.1225 20.5123 26.1225H18.1239C17.3235 26.1225 16.6744 25.4735 16.6744 24.6729V16.3137C16.6744 15.5132 17.3235 14.8641 18.1239 14.8641H20.5123C20.9452 14.8641 21.3328 15.0526 21.5998 15.3552C21.9429 15.7438 22.5361 15.7809 22.9249 15.4378C23.3135 15.0947 23.3506 14.5014 23.0075 14.1127Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.568 19.8294C26.9346 20.196 26.9346 20.7904 26.568 21.157L24.0646 23.6604C23.6979 24.027 23.1035 24.027 22.7369 23.6604C22.3703 23.2938 22.3703 22.6995 22.7369 22.3328L25.2403 19.8294C25.6069 19.4628 26.2014 19.4628 26.568 19.8294Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.568 21.157C26.9346 20.7904 26.9346 20.196 26.568 19.8294L24.0646 17.326C23.6979 16.9594 23.1035 16.9594 22.7369 17.326C22.3703 17.6926 22.3703 18.2869 22.7369 18.6536L25.2403 21.157C25.6069 21.5236 26.2014 21.5236 26.568 21.157Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0811 20.4932C18.0811 19.9748 18.5013 19.5544 19.0198 19.5544H25.2784C25.7969 19.5544 26.2172 19.9748 26.2172 20.4932C26.2172 21.0117 25.7969 21.432 25.2784 21.432H19.0198C18.5013 21.432 18.0811 21.0117 18.0811 20.4932Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.937 15.8656C12.9244 16.0133 12.918 16.1627 12.918 16.3137V24.6729C12.918 25.6064 13.1637 26.4825 13.5941 27.24H2.1905C0.980729 27.24 0 26.2593 0 25.0495V20.4534C0 19.6859 0.423567 18.9812 1.10123 18.6211C4.79461 16.6584 8.87829 15.7399 12.937 15.8656Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutLogo);
export default __webpack_public_path__ + "static/media/LogoutLogo.74ad77515d31ce2f9dfb812406a97f37.svg";
export { ForwardRef as ReactComponent };